import type { BackToBack } from 'epic/common-form/Trade';
import type { TradeConfirmationState } from 'state/uiPanelState/tradeConfirmation/tradeConfirm.model';

export const toExecutionBackToBack = ({
  isBackToBack,
  backToBackType,
  backedNotional,
  fileCode,
  noteNominal,
  isDelayedBackToBack,
  isDeltaAdjusted,
}: TradeConfirmationState): BackToBack | undefined => {
  if (isBackToBack.value === false) {
    return undefined;
  }

  const type = backToBackType?.value ?? 'None';
  const isDelayed = isDelayedBackToBack?.value ?? false;
  switch (type) {
    case 'ClientTrade':
      return {
        backToBackType: type,
        isDelayedBackToBack: isDelayed,
        ...(isDelayed
          ? {}
          : {
              backedNotional: backedNotional?.value,
              backedNotionalUnit: backedNotional?.unit === '%' ? 'Percentage' : 'Currency',
            }),
      };

    case 'HedgingTrade':
      return {
        backToBackType: type,
        isDelayedBackToBack: isDelayed,
        fileCode: fileCode?.value,
        initialNotional: noteNominal?.value,
        isDeltaAdjusted: isDeltaAdjusted?.value,
      };

    case 'None':
      return {
        backToBackType: type,
      };
  }
};
